<template>
  <div class="col-12 col-lg-4 col-xl-3 border-right">

    <div class="d-block d-lg-none">
      <a
        href="#"
        class="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
        v-if="selectedCoach"
        @click="showRecipients = ! showRecipients"
      >
        <div class="d-flex align-items-center">
          <img :src="selectedCoach.profile_image" class="rounded-circle mr-1" :alt="selectedCoach.first_name" width="40" height="40" />
          <div class="flex-grow-1 ml-3">
            {{ selectedCoach.first_name }} {{ selectedCoach.last_name }}
          </div>
        </div>
        <i class="fas fa-chevron-down"></i>
      </a>
    </div>

    <div v-show="showRecipients" class="users-box">
      <recipient
        :recipients="connections"
        :activeRecipient="selectedCoach"
        title="Connections"
      ></recipient>

      <recipient
        class="mb-3"
        :recipients="coaches"
        :activeRecipient="selectedCoach"
        title="Coaches"
      ></recipient>

      <recipient
        v-if="profile.is_coach"
        class="mb-3"
        :recipients="members"
        :activeRecipient="selectedCoach"
        title="Members"
      ></recipient>
    </div>

    <hr class="d-block d-lg-none mt-1 mb-0" />
  </div>
</template>

<script>
import Recipient from "@/components/Chatbox/Recipient";
export default {
  components: {Recipient},
  props: {
    coaches: Array,
    connections: Array,
    members: Array,
    selectedUser: String,
    selectedCoach: Object
  },
  watch:{
    $route () {
      this.toggleShowCoachesList()
    }
  },
  created: function() {
    this.toggleShowCoachesList()
  },
  mounted: function () {
    window.addEventListener('resize', () => {
      this.toggleShowCoachesList()
    })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', () => {
      this.toggleShowCoachesList()
    })
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      showRecipients: null,
    }
  },
  methods: {
    toggleShowCoachesList() {
      this.showRecipients = window.innerWidth > 992
    },
  }
}
</script>

<style scoped>

.list-group-item.selected {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.users-box {
  max-height: calc(100vh - 135px);
  /*max-height: calc(100vh - 200px);*/
  overflow-y: auto;
  overflow-x: hidden;
}

</style>
